<template>
  <div class="content">
    <h2 class="has-text-centered">Antal öl per bryggeri</h2>
    <table class="table is-narrow is-fullwidth">
      <thead>
        <tr>
          <th>Bryggeri</th>
          <th class="has-text-centered">Antal öl</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(data, index) in orderBy(beerData, ['count', 'brewery'], ['desc', 'asc']).slice(0, breweriesInList)">
          <tr @click="toggle($event, data.brewery_id)" :key="index" class="brewery" :data-key="data.brewery_id">
            <td><i :id="['expander__' + data.brewery_id]" class="expander"></i>{{ data.brewery }}</td>
            <td class="has-text-centered total-beers__count">{{ data.count }}</td>
          </tr>
          <tr :id="data.brewery_id" class="brewery__beers" :key="'row-' + index">
            <td colspan="2" class="beers-data">
              <table class="table is-striped is-fullwidth">
                <thead>
                  <tr class="beers-data__header">
                    <th>Namn</th>
                    <th class="has-text-centered" style="width:20%">Snitt</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(beer, bIndex) in orderBy(data.data, 'average', 'desc')" :key="bIndex">
                    <td><v-link :query="beer.name" showTitle="true" /></td>
                    <td class="has-text-centered">{{ beer.average }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </template>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2" class="has-text-right is-size-7 is-uppercase"><a @click="toogleBeersInList">{{ breweriesInListButtonText }}</a></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import VLink from '../VLink'
import _ from 'lodash'

export default {
  components: {VLink},
  data () {
    return {
      showAllBeers: false
    }
  },
  computed: {
    beerData: function () {
      let data = this.$store.getters.data
      let breweries = _.groupBy(data, 'brewery')
      let breweryData = {}

      for (const brewery in breweries) {
        if (breweries.hasOwnProperty(brewery)) {
          let id = brewery.toLowerCase()
          id = id.replace(/^[^a-z]+|[^\w:.-]+/gi, '')
          breweryData[brewery] = {
            brewery: breweries[brewery][0].brewery,
            brewery_id: id
          }
          breweryData[brewery].count = breweries[brewery].length
          breweryData[brewery].data = breweries[brewery]
        }
      }

      return breweryData
    },
    breweriesInList: function () {
      return this.showAllBeers ? -1 : 5
    },
    breweriesInListButtonText: function () {
      return this.showAllBeers ? 'Visa topp 5' : 'Visa alla'
    }
  },
  methods: {
    orderBy: function (data, keys, order) {
      let sorted = _.orderBy(data, keys, order)
      return sorted
    },
    toggle: function (event, id) {
      // Native javascript jQuery-isch selection
      const $ = (selector) => document.querySelector(selector)

      let expander = $('#expander__' + id)
      let beerList = $('#' + id)

      beerList.classList.toggle('is-visible')
      expander.classList.toggle('is-open')
    },
    toogleBeersInList: function () {
      this.showAllBeers = !this.showAllBeers
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../assets/styles/config.scss';
  .tag-breweries {
    margin-left: 10px;
  }
  .content-wrapper {
    .notification {
      position: inherit;
      top: -20px;
      width: inherit;
      left: initial;
      transform: initial;
    }
  }
  .container + .container {
    margin-top: 40px;
  }
  .content {
    .brewery {
      font-weight: bold;
      cursor: pointer;

      .expander {
        font-style: normal;
        margin-right: 10px;
        color: $primary;
        &::before {
          display: inline-block;
          content: '+';
          width: 10px;
        }
        &.is-open {
          &::before {
            content: '–';
          }
        }
      }
    }
    .brewery__beers {
      display: none;
      &.is-visible {
        display: table-row;
      }
      &--td {
        display: table-cell;
      }
      .beers-data {
        padding: 15px;
      }
      .beers-data__header {
        border-bottom: 2px solid #ccc;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// TopBreweries.vue?a6ffce70